import React from "react";
import { Trans, useI18n } from "@bookingcom/lingojs-react";
import { Stack, Text, Title } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { isSirfApplied } from "../../../store/selectors/sirf.js";
import SirfWebCheckinReminder from "../SirfWebCheckinReminder/index.js";
export const CheckinHowTo = ({ order }) => {
    const i18n = useI18n();
    const appliedSubsidizedFares = order.airOrder.appliedSubsidizedFares || [];
    return (React.createElement(Stack, { gap: 2 },
        React.createElement(Title, { variant: "headline_3", title: i18n.trans(t("flights_pb_checkin_howto_title")) }),
        React.createElement(Text, { variant: "body_2" },
            "1.",
            " ",
            React.createElement(Trans, { tag: "flights_pb_checkin_howto_body_1", variables: { start_bold: "<0>", end_bold: "</0>" }, components: [React.createElement("strong", { key: 0 })] })),
        React.createElement(Text, { variant: "body_2" },
            "2.",
            " ",
            React.createElement(Trans, { tag: "flights_pb_checkin_howto_body_2", variables: { start_bold: "<0>", end_bold: "</0>" }, components: [React.createElement("strong", { key: 0 })] })),
        React.createElement(Text, { variant: "body_2" },
            "3.",
            " ",
            React.createElement(Trans, { tag: "flights_pb_checkin_howto_body_3", variables: { start_bold: "<0>", end_bold: "</0>" }, components: [React.createElement("strong", { key: 0 })] })),
        isSirfApplied(appliedSubsidizedFares) && React.createElement(SirfWebCheckinReminder, { order: order })));
};
